import { forwardRef } from 'react'
import Linkify from 'linkify-react'
import type { Opts } from 'linkifyjs'
import { MAX_LINKIFY_LENGTH } from 'utils/linkify'

interface LinkifiedTextProps {
	/** Plain user-typed text. URLs inside it render as external links. Whitespace handling is inherited from the parent. */
	text: string | null | undefined
	className?: string
}

const LINKIFY_OPTIONS: Opts = {
	defaultProtocol: 'https',
	target: '_blank',
	rel: 'noopener noreferrer',
	// Inherit the surrounding colour (ticket panels use host-chosen backgrounds); the underline marks the link.
	className: { url: 'underline [overflow-wrap:anywhere] hover:opacity-80' },
}

/**
 * Renders plain user-typed text and turns any URLs in it into clickable external links.
 * Links are built as React elements — the text is never treated as HTML.
 */
const LinkifiedText = forwardRef<HTMLSpanElement, LinkifiedTextProps>(function LinkifiedText(
	{ text, className },
	ref
) {
	if (!text) return null

	return (
		<span ref={ref} className={className}>
			{text.length > MAX_LINKIFY_LENGTH ? text : <Linkify options={LINKIFY_OPTIONS}>{text}</Linkify>}
		</span>
	)
})

LinkifiedText.displayName = 'LinkifiedText'

export { LinkifiedText }
export type { LinkifiedTextProps }
